// @owners { team: patient-health }
// eslint-disable-next-line import/no-deprecated
import { Column, getScreenSize } from '@alto/design-system';
// eslint-disable-next-line @alto/no-pocky-import
import { Text, palette, spacing } from '@alto/pocky';
import React from 'react';
import styled from 'styled-components';
import { PRESCRIPTION_STATES } from '~shared/constants';
import { inactiveText } from '~shared/features/my-meds/helper';
import { type Prescription } from '~shared/types/clients';
import PrescriptionInactiveArchived from './PrescriptionInactiveArchivedContainer';

export const InactiveContainer = styled.div<{ isSMScreenOrBigger: boolean }>`
  display: flex;
  border-bottom: ${spacing.borderWidth} solid ${palette.grey2};
  padding: ${spacing.smSpacing} ${spacing.mdSpacing};
  align-items: center;
  justify-content: space-between;

  > *:not(:last-child) {
    margin-right: ${spacing.smSpacing};
  }

  ${({ isSMScreenOrBigger }) => !isSMScreenOrBigger && `flex-direction: column;`}
`;

type Props = {
  readonly prescription: Prescription;
};

class InactivePrescription extends React.Component<Props> {
  render() {
    const { prescription } = this.props;
    // eslint-disable-next-line import/no-deprecated
    const { isSMScreenOrBigger } = getScreenSize();

    return (
      <InactiveContainer isSMScreenOrBigger={isSMScreenOrBigger}>
        <Column>
          <Text>{inactiveText(prescription)}</Text>
        </Column>
      </InactiveContainer>
    );
  }
}

export default function PrescriptionInactive({ prescription }: { readonly prescription: Prescription }) {
  const { active_state } = prescription;

  if (active_state === PRESCRIPTION_STATES.ARCHIVED) {
    return <PrescriptionInactiveArchived prescription={prescription} />;
  }

  return <InactivePrescription prescription={prescription} />;
}
